export default __webpack_public_path__ + "static/media/R870_7.f332242b.png";